import l from '../lang';

export default {
	'routes': {
		'create': 'fax.create',
		'show': 'fax.show',
		'index': 'fax.index',
	},
	'delete-single': l.t('fax.delete-single', 'Are you sure you want to delete this fax?'),
	'delete-filtered': l.t('fax.delete-filtered', 'Are you sure you want to delete all filtered faxes?'),
	'delete-all': l.t('fax.delete-all', 'Are you sure you want to delete all faxes?'),
	'successfull-creation': l.t('fax.successfully-created', 'Your fax has been added'),
	'successfull-update': l.t('app.successful-update', 'Your changes have been saved'),
	'failed-creation': l.t('fax.failed-creation', 'There was a problem creating your fax'),
	'failed-update': l.t('app.update-error', 'An error occurred while attempting to save your changes. Please try again.'),
};
